import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { UtilsService } from '../core/services/utils.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private readonly utilService: UtilsService) { }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error) => {
        let errorMessage: any;
        const apiError = error.error;

        if (apiError?.code === 401 || apiError?.code === 500) {
          errorMessage = apiError.result?.error;
          this.utilService.SharingData.next(errorMessage);
        }

        if ([440].indexOf(error.status) !== -1) {
          if (error.status === 440) {
            errorMessage =
              'Session Expired! Please close this tab and try to re-login from DMINT Platform.';
            this.utilService.SharingData.next(errorMessage);
            this.utilService.checkPopup(true);
          }
        }

        if (
          apiError?.code === 422 ||
          apiError?.message === 'Unprocessable Entity'
        ) {
          errorMessage = apiError.result?.error;
          this.utilService.SharingData.next(errorMessage);
        }

        if (apiError?.code === 400) {
          errorMessage = apiError.result?.error;
          this.utilService.SharingData.next(errorMessage);
        }

        if (apiError?.code === 404 || apiError?.message === 'Not Found') {
          errorMessage = apiError.result?.error;
          this.utilService.SharingData.next(errorMessage);
        }

        return throwError(() => error);
      })
    );
  }
}
